import { useMemo } from 'react';

export const useGhostNodes = (isEmptyStateSingleEntity, nodes) => {
  return useMemo(() => {
    if (!isEmptyStateSingleEntity || nodes.length === 0) {
      return { ghostNodes: [], ghostEdges: [] };
    }

    const existingNode = nodes[0];
    const existingPosition = existingNode.position;
    
    const ghostNode = {
      id: 'ghost-add-entity',
      type: 'ghost-entity-node',
      position: {
        x: existingPosition.x,
        y: existingPosition.y + 200
      },
      data: {
        name: 'Add holding entity',
        color: '#D7DEE7',
        isGhost: true
      },
      draggable: false,
      selectable: false,
      connectable: false,
      deletable: false
    };

    const ghostEdge = {
      id: 'ghost-edge',
      source: existingNode.id,
      target: 'ghost-add-entity',
      type: 'custom-entity-edge',
      data: {
        ownership: '100',
        label: '100%',
        percentage: '100',
        isGhost: true
      },
      label: '100%',
      animated: false,
      selectable: false,
      deletable: false,
      style: {
        stroke: '#D1D5DB',
        strokeDasharray: '5,5',
        strokeWidth: 2,
        pointerEvents: 'none'
      },
      markerEnd: {
        type: 'arrowclosed',
        width: 15,
        height: 15,
        color: '#D1D5DB'
      }
    };

    return { ghostNodes: [ghostNode], ghostEdges: [ghostEdge] };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmptyStateSingleEntity, nodes.length, nodes[0]?.id, nodes[0]?.position?.x, nodes[0]?.position?.y]);
}; 